import {Field} from "./field";
import {Operator} from "./operator";
import {Value} from "./value";
import {Timeframe} from "./time";
import {ConditionCompose} from "./compose";

export enum ConditionType {
    AND = 'AND',
    COMPARE = 'COMPARE',
    COMPOSE = 'COMPOSE',
    MANAGED = 'MANAGED',
}

export type Condition = ConditionAnd | ConditionCompare | ConditionCompose | ConditionManaged;

export type ConditionAnd = {
    id: string;
    type: ConditionType.AND,
    conditions: Array<Condition>
}

export type ConditionCompare = {
    id: string;
    type: ConditionType.COMPARE;
    field: Field;
    operator: Operator;
    value: Value;
    timeframe?: Timeframe;
}

export type ConditionManaged = {
    id: string;
    type: ConditionType.MANAGED;
    managed: string;
}

